import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import HomeTopCard from "../../../components/HomeComponents/HomeTopCard";
import "../userDashboard.css";

export const UserCategoryListPage = () => {

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar showBackButton displayType="logo" showNotification showProfileBtn></TopBar>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserCategoryListPage;
